module.exports = __webpack_public_path__ + "img/cillectove14.fb67bde7.png";